import { useMemo } from 'react';

import { formatPrice } from '@/services/formatter';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { TBankOffers } from '../../../types/bank-offer.types';

interface IBerekeAdditional {
  PartnerName: string;
  down_payment: number;
  interest_rate: number;
  kasko_amount: number;
  loan_amount: number;
  monthly_payment: number;
  ns_amount: number;
  term: number;
}

interface IProps {
  bankOffer: TBankOffers;
  offerDetailsModal: boolean | string;
}

const useAdditionalHelpers = ({ bankOffer, offerDetailsModal }: IProps) => {
  const additionalProducts = useMemo(() => {
    const products = {
      title: 'Доп. продукты',
      content: [] as string[]
    };

    const isValidJSON = checkIsValidJSON(bankOffer.responseApprovedBody || '');

    const parsedApprovedBody =
      isValidJSON && bankOffer.responseApprovedBody
        ? (JSON.parse(bankOffer.responseApprovedBody) as {
            additional?: IBerekeAdditional;
          })
        : null;
    // Дополнительные поля в приоритете
    if (parsedApprovedBody?.additional) {
      if (parsedApprovedBody.additional.kasko_amount) {
        products.content.push(
          `КАСКО ${formatPrice(parsedApprovedBody.additional.kasko_amount)} ₸`
        );
      }
      if (parsedApprovedBody.additional.ns_amount) {
        products.content.push(
          `НС Страхование ${formatPrice(parsedApprovedBody.additional.ns_amount)} ₸`
        );
      }
    } else {
      if (bankOffer.insuranceAmount) {
        const insuranceAmount = bankOffer.insuranceAmount.replace(/\s/g, '');
        if (insuranceAmount) {
          products.content.push(`КАСКО ${formatPrice(insuranceAmount)} ₸`);
        }
      } else if (
        bankOffer.productInfo &&
        typeof bankOffer.productInfo === 'object'
      ) {
        products.content.push(
          `КАСКО ${
            bankOffer.productInfo?.product?.loan_period
              ? bankOffer.productInfo?.product.loan_period
              : ''
          }`
        );
      }
    }

    return products;
  }, [
    bankOffer.insuranceAmount,
    bankOffer.productInfo,
    bankOffer.responseApprovedBody
  ]);

  const getDescription = () => {
    const description = bankOffer.bankDescription || '';
    const isValidJSON = checkIsValidJSON(description);
    const parsedJSON =
      isValidJSON && JSON.stringify(JSON.parse(description), null, 2);

    return typeof offerDetailsModal === 'string'
      ? offerDetailsModal
      : parsedJSON || description;
  };

  return { additionalProducts, getDescription };
};

export default useAdditionalHelpers;
